import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const AddressesPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("stubs.addressesTitle")} />
      <p>{t("stubs.addressesPlaceholder")}</p>
    </div>
  );
};

export default AddressesPage;
